import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageConstructionComponent } from './../core/components/page-construction/page-construction.component';

import { FooterComponent } from '../core/components/footer/footer.component';
import { HeaderComponent } from '../core/components/header/header.component';
import { MenuDesktopComponent } from '../core/components/menu-desktop/menu-desktop.component';
import { UserActionsComponent } from '../core/components/user-actions/user-actions.component';
import { ExternalComponent } from '../pages/layouts/external/external.component';
import { LayoutAuthenticatedComponent } from '../pages/layouts/layout-authenticated/layout-authenticated.component';

import { GavePermissionComponent } from '../shared/componentes/gave-permission/gave-permission.component';
import { AuthLogoutGuard } from '../utils/auth-guards/auth-logout.guard';

import { SharedModule } from '../shared/shared.module';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'login',
    component: ExternalComponent,
    loadChildren: () => import('../pages/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: 'especialista',
    component: ExternalComponent,
    loadChildren: () => import('../pages/specialist/specialist.module').then(m => m.SpecialistModule)
  },
  {
    path: 'captador',
    component: ExternalComponent,
    loadChildren: () => import('../pages/pickup/pickup.module').then(m => m.PickupModule)
  },
  {
    path: 'lote',
    component: LayoutAuthenticatedComponent,
    // canActivate: [AuthLogoutGuard],
    loadChildren: () => import('../pages/lots-register/lots.module').then(m => m.LotsModule)
  },
  {
    path: 'quero-vender',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/iwant-to-sell/iwant-to-sell.module').then(m => m.IwantToSellModule)
  },
  {
    path: 'lotes-ganhos',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/won-lots/won-lots.module').then(m => m.WonLotsModule)
  },
  {
    path: 'perfil',
    component: LayoutAuthenticatedComponent,
    canActivate: [AuthLogoutGuard],
    loadChildren: () => import('../pages/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'leiloes',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/auctions/auctions.module').then(m => m.AuctionsModule)
  },
  {
    path: 'leilao',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/auction-id/auction.module').then(m => m.AuctionModule)
  },
  {
    path: 'lotes-em-leilao',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/lots-in-auction/lots-in-auction.module').then(m => m.LotsInAuctionModule)
  },
  {
    path: 'lotes-vendidos',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/lots-sold/lots-sold.module').then(m => m.LostSoldModule)
  },
  {
    path: 'quem-somos',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/page-about-us/page-about-us.module').then(m => m.PageAboutUsModule)
  },
  {
    path: 'os-especialistas',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/page-specialist/page-specialist.module').then(m => m.PageSpecialistModule)
  },
  {
    path: 'termos-condicoes',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/page-terms-and-conditions/page-terms-and-conditions.module').then(m => m.PageTermsAndConditionsModule)
  },
  {
    path: 'politicas-comprador',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/page-buyer-policies/page-buyer-policies.module').then(m => m.PageBuyerModule)
  },
  {
    path: 'politicas-vendedor',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/page-seller-policies/page-seller-policies.module').then(m => m.PageSellerPoliciesModule)
  },
  {
    path: 'perguntas-frequentes',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/page-common-questions/page-common-questions.module').then(m => m.PageCommonQuestionsModule)
  },
  {
    path: 'contato',
    component: LayoutAuthenticatedComponent,
    loadChildren: () => import('../pages/page-contact/page-contact.module').then(m => m.PageContactModule)
  },
  {
    path: 'politica-de-privacidade',
    component: LayoutAuthenticatedComponent,
    loadChildren: () =>
    import('../pages/page-privacy-policy/page-privacy-policy.module')
      .then(m => m.PagePrivacyPolicyModule)
  },
  {
    path: 'politica-de-cookies',
    component: LayoutAuthenticatedComponent,
    loadChildren: () =>
    import('../pages/page-cookie-policy/page-cookie-policy.module')
      .then(m => m.PageCookiePolicyModule)
  },
  {
    path: '**',
    redirectTo: ''
  },
];

@NgModule({
  declarations: [
    MenuDesktopComponent,
    UserActionsComponent,
    HeaderComponent,
    FooterComponent,
    ExternalComponent,
    LayoutAuthenticatedComponent,
    PageConstructionComponent,
    GavePermissionComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forRoot(routes, {}), //, { useHash: true }
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {}
